import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'site_settings',
    initialState: {
        logo: null,
    },
    reducers: {
        getSettings: (state, action) => {
            const data = action.payload
            // DRF list javob formatini qo'llab-quvvatlash
            const list = Array.isArray(data) ? data : (data.results || [])
            if (list.length > 0) {
                state.logo = list[0].logo
            }
        },
    }
})

export const getSiteSettings = () => apiCall({
    url: 'site-settings/',
    method: 'GET',
    onSuccess: slice.actions.getSettings.type
})

export default slice.reducer
